<template>
	<div>
		<b-button class="mt-2" @click="showEmailModal">{{ this.$t('notifications.sendNewNotification') }}</b-button>
		<AjaxTable id="reservations-mail-history-list" stacked="lg" :filters="filtersClean" :columns="modelColumns" resource="reservations-mail-history" responsive>
			<template #cell(change)="row">
                <span v-for="(change,i) in row.item.changes" :key="`${modelId}-${i}`">
                    {{ change }}
                    <br/>
                </span>
			</template>
		</AjaxTable>
		<b-overlay :show="loading" no-wrap rounded></b-overlay>
		<b-modal hide-footer size="md" id="modal-send-email" ref="modal-send-email" :title="this.$t('notifications.sendNotification')">
			<FormNotification
				:listPayments="listPayments"
				:listTemplates="listTemplates"
				:selected="selected"
			/>
		</b-modal>
	</div>
</template>

<script>
import AjaxTable from "../../../helpers/AjaxTable.vue";
import api from "../../../../api.js";
import FormNotification from "../notifications/Form";
import {mapState} from "vuex";

export default {
	components: {AjaxTable, FormNotification},
	props: {
		filters: {
			default: () => ({}),
			type: Object,
			required: false
		},
		selected: {
			type: Object,
			required: false,
			default: () => ({})
		}
	},
	data() {
		return {
			loading: false,
			modelColumns: [
				{key: "id", label: this.$t('notifications.id')},
				{key: "status", label: this.$t('notifications.status')},
				{key: "creationDatetime", label: this.$t('notifications.creationDatetime')},
				{key: "user", label: this.$t('notifications.user')},
				{key: "type", label: this.$t('notifications.type')},
				{key: "notificationType", label: this.$t('notifications.notificationType')},
				{key: "dataSource", label: this.$t('notifications.dataSource')},
				{key: "destination", label: this.$t('notifications.destination')},
			],
			listTemplates: [],
			listPayments: []
		};
	},
	methods: {
		showEmailModal() {
			this.$refs["modal-send-email"].show()
		},
		getPayments() {
			return api(this)
				.get(`reservations/${this.viewModel.id}/payments`)
				.then(res => {
					this.listPayments = res.data.payments;
				})
				.catch(this.$root.handleRequestError);
		},
		getTemplates() {
			return api(this)
				.get(`/notifications/templates`)
				.then((res) => {
					this.listTemplates = res.data;
				})
				.catch(this.$root.handleRequestError)
				.finally(() => {
					this.loading = false;
				})
		},
		async fetch() {
			this.loading = true
			await this.getPayments();
			await this.getTemplates();
			this.loading = false

		}
	},
	computed: {
		...mapState("reservation", ["viewModel"]),
		filtersClean() {
			let filters = {id: this.viewModel.id}
			let optionalFilters = {...this.filters}
			try {
				if ((Object.keys(optionalFilters).length) > 0 && 'only' in optionalFilters) {
					Object.assign(filters, optionalFilters);
				}
			} catch (err) {
				filters = {id: this.viewModel.id};
			}

			return filters;
		}
	},
	mounted() {
		this.fetch();
	},
};
</script>

<style>
#reservations-history-list tr td {
	/*white-space: pre !important;*/
}
</style>
